/**
 * Serbian overrides for the tasks screens.
 *
 * Bosnian moved from ijekavica to ekavica — *uspjela* to *uspela*, *mjesec*
 * to *mesec*, *prijedlog* to *predlog*. Where the two standards agree there
 * is no entry, which is why this file is short and should stay that way.
 *
 * Latin script, matching the rest of the application.
 */

import type { TasksSlice } from '../bs/tasks'

export const tasks: Partial<TasksSlice> = {
  // *ovdje* → *ovde*, *uvijek* → *uvek*, and the whole *dodijeliti* family
  // loses its jat: *dodijeljen* → *dodeljen*, *dodjela* → *dodela*.
  'tasks.empty.manager':
    'Ovde su zadaci koji su dodeljeni vama. Zadatak uvek pripada nekoj prijavi — dodelite ga dugmetom „Novi zadatak” ili sa same prijave.',
  'tasks.empty.worker': 'Zadatke dodeljuje nadležni sa konkretne prijave.',

  'tasks.updateFailed': 'Ažuriranje nije uspelo.',

  'tasks.new.submit': 'Dodeli zadatak',
  'tasks.new.submission.hint':
    'Zadatak se uvek veže za prijavu. Prikazane su otvorene prijave.',
  'tasks.new.submission.none':
    'Nema otvorenih prijava. Zadatak se dodeljuje na prijavu, pa je prvo treba evidentirati.',
  'tasks.new.title.placeholder': 'npr. Zameniti ležaj na hoblu',
  'tasks.new.description.placeholder':
    'Neobavezno — šta tačno treba uraditi, koji delovi su potrebni.',
  'tasks.new.assigned': 'Zadatak je dodeljen.',
  'tasks.new.failed': 'Dodela nije uspela.',

  // *naljepnica* → *nalepnica*, *usmjerite* → *usmerite*, *zamijenjena* →
  // *zamenjena*, *provjera* → *provera*.
  'tasks.scan.subtitle':
    'Usmerite kameru na nalepnicu na mašini. Prijava se otvara sa već izabranim radnim centrom.',
  'tasks.scan.unknownCode': 'QR kod nije prepoznat. Obratite se nadležnom za novu nalepnicu.',

  'tasks.qr.checkingSession': 'Provera sesije…',
  'tasks.qr.unknownCode':
    'QR kod nije prepoznat. Nalepnica je možda zamenjena — javite nadležnom.',

  // *nalepnica*, *važi*, and *treba da* for the Bosnian *trebate*.
  'tasks.qr.otherPlant':
    'Ova mašina nije ni u jednom od pogona kojima imate pristup — ili nalepnica više ne važi. Ako na njoj treba nešto da prijavite, obratite se administratoru.',
}
